import Markdown from 'markdown-to-jsx'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import type { ThemeColorsType } from '../../types/ComponentTypes'
import Icon from './Icon'
import type { IconPropsType } from './Icon'

type IconTextPropTypes = IconPropsType & {
  text: string
  reversed?: boolean
  center?: boolean
  iconColor?: ThemeColorsType
  textModifier?: string
  headline?: string
  iconClass?: string
}

const IconText: React.FC<IconTextPropTypes> = ({
  className = '',
  text,
  icon = 'heart',
  iconColor = null,
  color = 'secondary',
  size = 'native',
  reversed = true,
  center = false,
  textModifier,
  headline,
  iconClass,
}) => {
  const classes: string[] = []

  if (className) {
    classes.push(className)
  }
  if (color) {
    classes.push(`text-color-${color}`)
  }

  const renderIcon = () => (
    <Icon className={cn('icon-text__icon', iconClass)} color={iconColor} icon={icon} size={size} />
  )

  const renderText = () => (
    <div>
      {headline && <h3 className="text-text-color">{headline}</h3>}
      <Markdown
        className={cn('icon-text__text', { [`icon-text__text--${textModifier}`]: !!textModifier }, 'font-normal')}
      >
        {text}
      </Markdown>
    </div>
  )

  return (
    <div
      className={cn(
        'icon-text',
        { 'icon-text--reversed': reversed, 'icon-text--center': center },
        classes ? classes.join(' ') : '',
      )}
    >
      {reversed ? (
        <>
          {renderIcon()}
          {renderText()}
        </>
      ) : (
        <>
          {renderText()}
          {renderIcon()}
        </>
      )}
    </div>
  )
}

export default IconText
